import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { IpPage } from './pages/IpPage';
import { StakeholdersPage } from './pages/StakeholdersPage';
import { ContractsPage } from './pages/ContractsPage';
import { UsersPage } from './pages/UsersPage';
import { LandingPage } from './pages/LandingPage';
import { useAppStore } from './contexts/AppStore';

// Componente para proteger rutas
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAppStore((state) => state.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta de login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />

        {/* Rutas protegidas */}
        <Route
          path="/demo"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="proyectos" element={<ProjectsPage />} />
          <Route path="proyectos/:id" element={<ProjectDetailPage />} />
          <Route path="propiedad-intelectual" element={<IpPage />} />
          <Route path="stakeholders" element={<StakeholdersPage />} />
          <Route path="contratos" element={<ContractsPage />} />
          <Route path="usuarios" element={<UsersPage />} />
        </Route>

        {/* Redirección por defecto */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
